/**
 * @ngdoc controller
 * @name ProfileController
 * @description
 * This component renders the Profile section.
 *
 * @memberof profile
 */
class ProfileController {
  /**
   * Class constructor
   * @param {Service} $location        To know wheter we need to refresh
   *                                   the profile media or not
   * @param {Object}  $rootScope       To broadcast the tracking events.
   * @param {Service} appConstant      To get the profile loadingTemplates size.
   * @param {Service} campaignsService To get the list of campaigns.
   * @param {Service} ccaSession       To get the current user.
   * @param {Service} errorHandler     To show any errors.
   * @param {Service} profileService   To get the list of media.
   * @param {Service} uploadQueue      We're going to need this to allow upload on this section.
   * @param {Object}  TRACKING_EVENTS  To get the name of the events to be broadcasted.
   * @ignore
   */
  constructor(
    $location,
    $rootScope,
    appConstant,
    campaignsService,
    ccaSession,
    errorHandler,
    profileService,
    uploadQueue,
    TRACKING_EVENTS,
  ) {
    'ngInject';

    /**
     * The local reference to the `$location` service.
     * @type {Object}
     */
    this.$location = $location;
    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `campaignsService` service.
     * @type {Object}
     */
    this.campaignsService = campaignsService;
    /**
     * The local reference to the `errorHandler` service.
     * @type {Object}
     */
    this.errorHandler = errorHandler;
    /**
     * The local reference to the `profileService` service.
     * @type {Object}
     */
    this.profileService = profileService;
    /**
     * Local reference for the upload Queue Service.
     * @type {Service}
     */
    this.uploadQueue = uploadQueue;
    /**
     * The local reference to the `TRACKING_EVENTS` constant.
     * @type {Object}
     */
    this.TRACKING_EVENTS = TRACKING_EVENTS;
    /**
     * The local reference to the `user` object.
     * @type {Object}
     */
    this.user = ccaSession.getUser();
    /**
     * The local reference to the `media` array.
     * @type {?Array}
     */
    this.media = null;
    /**
     * List of place holder; we need a list to iterate on the template.
     * @type {Array}
     */
    this.loadingItems = new Array(appConstant.pagination.profile.loadingTemplates);
    /**
     * Local reference if the Logout should be shown or not.
     * @type {Boolean}
     */
    this.isLogOutVisible = false;
    /**
     * Local reference to the `logOutButtons` array.
     * These are the buttons the Logout modal should display.
     * @type {Array}
     */
    this.logOutButtons = [{
      title: 'Cancel',
      class: '-secondary',
      action: this.hideLogout.bind(this),
    }, {
      title: 'Log out',
      class: '-destructive',
      action: this.logout.bind(this),
    }];
    /**
     * Local reference if the user can upload media.
     * @type {Boolean}
     */
    this.canUploadMedia = false;
  }
  /**
   * Handle the load of the media.
   * @param {Boolean} first flag to get the Media
   *                  for the first time or load more.
   */
  _loadMedia(first) {
    this.profileService.load(first).then((media) => {
      this.media = media;
    })
    .catch((err) => this.errorHandler.handleError(err));
  }
  /**
   * Load the first batch of media objects and set the canUploadMedia flag.
   */
  $onInit() {
    this._loadMedia(true);

    this.campaignsService.load(true)
    .then((campaigns) => {
      this.canUploadMedia = campaigns.length > 0;
    });
  }
  /**
   * Handle the infinite scroll load more.
   */
  loadMoreMedia() {
    this._loadMedia(false);
  }
  /**
   * Add the FILE oject to the upload queue service.
   * @param {FileList} selectedFiles list of seleted files by the user.
   */
  fileSelected(selectedFiles) {
    this.uploadQueue.addItems(selectedFiles);
    this.$location.url('/upload');
  }
  /**
   * Handle the show of Logout modal.
   */
  showLogout() {
    this.isLogOutVisible = true;
    this.trackClick('Logout');
  }
  /**
   * Handle the hide of Logout modal.
   */
  hideLogout() {
    this.isLogOutVisible = false;
  }
  /**
   * Handle the logout action.
   */
  logout() {
    this.$location.url('/logout');
  }
  /**
   * Track the click event.
   * @param {String} type the type of click event to track.
   */
  trackClick(type) {
    this.$rootScope.$broadcast(this.TRACKING_EVENTS.me[`click${type}`]);
  }
}

export default ProfileController;



// WEBPACK FOOTER //
// ./src/frontend/modules/profile/components/profile/profile.controller.js